import { useState, useEffect, useCallback, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { fetchSliders } from "../../config/firestoreRest";
import { getUtmParams, openWhatsAppConsulta } from "../../config/whatsappConfig";
import HeroCarousel from "./HeroCarousel";

const WhatsAppModal = lazy(() => import("../WhatsAppFlotante/WhatsAppModal"));

const ROUTE_FILTERS = {
  plan: (b) => b.plan === true,
  convencional: (b) => b.convencional === true,
  grandesclientes: (b) => b.grandesclientes === true,
};

const getSlidesForRoute = (banners, pathname, isMobile) => {
  const tipo = pathname.split("/").pop();
  const source = isMobile ? banners[0]?.mobile : banners[0]?.desktop;
  if (!source) return [];

  const filter = ROUTE_FILTERS[tipo];
  const slides = !filter ? source : source.filter(filter);
  return slides.length > 0 ? slides : source;
};

const Slider = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const location = useLocation();

  useEffect(() => {
    fetchSliders()
      .then((data) => setBanners(data))
      .catch((error) => {
        console.error("Error al obtener sliders:", error);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleModal = useCallback(() => setOpen(true), []);

  const handleModalSubmit = async (values) => {
    setSubmitting(true);
    try {
      const { utm_source, utm_medium, utm_campaign } = getUtmParams();
      const { updateFirestoreEntry } = await import("../../config/useFirestoreData");
      await updateFirestoreEntry("consultas", "validaciones", {
        ...values,
        utm_source,
        utm_medium,
        utm_campaign,
      });
      setOpen(false);
      openWhatsAppConsulta();
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setSubmitting(false);
    }
  };

  const desktopSlides = getSlidesForRoute(banners, location.pathname, false);
  const mobileSlides = getSlidesForRoute(banners, location.pathname, true);
  const hasSlides = desktopSlides.length > 0 || mobileSlides.length > 0;

  if (loading || !hasSlides) {
    return (
      open && (
        <Suspense fallback={null}>
          <WhatsAppModal
            open={open}
            onClose={() => setOpen(false)}
            onSubmit={handleModalSubmit}
            loading={submitting}
          />
        </Suspense>
      )
    );
  }

  return (
    <>
      <div id="inicio">
        <div className="d-md-block d-none hero-slider">
          <HeroCarousel slides={desktopSlides} onSlideClick={handleModal} />
        </div>
        <div className="d-md-none d-block hero-slider">
          <HeroCarousel slides={mobileSlides} onSlideClick={handleModal} />
        </div>
      </div>
      {open && (
        <Suspense fallback={null}>
          <WhatsAppModal
            open={open}
            onClose={() => setOpen(false)}
            onSubmit={handleModalSubmit}
            loading={submitting}
          />
        </Suspense>
      )}
    </>
  );
};

export default Slider;
